import { render, staticRenderFns } from "./XrfGroupInput.vue?vue&type=template&id=ac3f4b2c&"
import script from "./XrfGroupInput.vue?vue&type=script&lang=js&"
export * from "./XrfGroupInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports